/**
 * Configuration utilities for environment variables
 *
 * Deployment variant (`VITE_APP_ENV`):
 * - Set `VITE_APP_ENV=test` when building the portal for the test/staging host so
 *   subscription WIP tiles (abonnements, atelier, etc.) appear on the home for
 *   eligible roles.
 * - For production builds, use `prod`, `production`, or leave unset — WIP tiles stay hidden.
 * Values are baked in at `vite build` time (Vite inlines `import.meta.env.*`).
 */

const config = {
  api: {
    // In development, use empty string to leverage Vite proxy
    // In production, use environment variable or fall back to relative path
    baseUrl: import.meta.env.VITE_API_BASE_URL || "",
  },
} as const;

/**
 * Get the API base URL from environment variables
 * In development, returns relative path to use Vite proxy
 * In production, can be configured via VITE_API_BASE_URL
 */
export const getApiBaseUrl = (): string => {
  return config.api.baseUrl ? `${config.api.baseUrl}/api` : "/api";
};

/** True only for a test deployment build — use for UI like an "Environnement test" banner (not shown in local dev unless VITE_APP_ENV=test). */
export function isDeployedTestEnvironment(): boolean {
  return import.meta.env.VITE_APP_ENV === "test";
}
